__turbopack_context__.v({
  "align-center": "dialog-module__3I9THG__align-center",
  "close": "dialog-module__3I9THG__close",
  "content": "dialog-module__3I9THG__content",
  "contentFadeInUp": "dialog-module__3I9THG__contentFadeInUp",
  "contentFadeOutDown": "dialog-module__3I9THG__contentFadeOutDown",
  "description": "dialog-module__3I9THG__description",
  "footer": "dialog-module__3I9THG__footer",
  "footerPinned": "dialog-module__3I9THG__footerPinned",
  "footerUnpinned": "dialog-module__3I9THG__footerUnpinned",
  "header": "dialog-module__3I9THG__header",
  "headerCenter": "dialog-module__3I9THG__headerCenter",
  "headerHasLeft": "dialog-module__3I9THG__headerHasLeft",
  "headerLg": "dialog-module__3I9THG__headerLg",
  "left": "dialog-module__3I9THG__left",
  "overlay": "dialog-module__3I9THG__overlay",
  "overlayFadeIn": "dialog-module__3I9THG__overlayFadeIn",
  "overlayFadeOut": "dialog-module__3I9THG__overlayFadeOut",
  "peeking": "dialog-module__3I9THG__peeking",
  "size-lg": "dialog-module__3I9THG__size-lg",
  "size-md": "dialog-module__3I9THG__size-md",
  "size-sm": "dialog-module__3I9THG__size-sm",
  "size-xl": "dialog-module__3I9THG__size-xl",
  "srOnly": "dialog-module__3I9THG__srOnly",
  "title": "dialog-module__3I9THG__title",
  "titleSelect": "dialog-module__3I9THG__titleSelect",
});
